/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GTVMinimumsResponseDTO } from '../models/gtvminimums-response-dto';
import { GTVPostUsageEventsResponseDTO } from '../models/gtvpost-usage-events-response-dto';
import { GTVInvoicesReadyDTO } from '../models/gtvinvoices-ready-dto';
import { GTVChargeCategoryDTO } from '../models/gtvcharge-category-dto';
@Injectable({
  providedIn: 'root',
})
class GTVService extends __BaseService {
  static readonly ProcessMinimumsPath = '/gtv/processminimums';
  static readonly ProcessUsageEventsPath = '/gtv/processusageevents/{clientId}';
  static readonly ProcessInvoiceReadyNotificationPath = '/gtv/processinvoicereadynotification';
  static readonly GetBillCyclesNotInSimulateStatusPath = '/gtv/billcyclesnotinsimulatestatus';
  static readonly GetChargeCategoryByNamePath = '/gtv/chargecategorylookup/{name}';
  static readonly SyncClientToGtvPath = '/gtv/syncClientToGtv/{clientId}';
  static readonly ClearBillingMinimumPath = '/gtv/cleargtvminimums/{clientId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param Authorization Bearer token
   * @return Success
   */
  ProcessMinimumsResponse(Authorization?: string): __Observable<__StrictHttpResponse<GTVMinimumsResponseDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gtv/processminimums`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GTVMinimumsResponseDTO>;
      })
    );
  }
  /**
   * @param Authorization Bearer token
   * @return Success
   */
  ProcessMinimums(Authorization?: string): __Observable<GTVMinimumsResponseDTO> {
    return this.ProcessMinimumsResponse(Authorization).pipe(
      __map(_r => _r.body as GTVMinimumsResponseDTO)
    );
  }

  /**
   * @param params The `GTVService.ProcessUsageEventsParams` containing the following parameters:
   *
   * - `clientId`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  ProcessUsageEventsResponse(params: GTVService.ProcessUsageEventsParams): __Observable<__StrictHttpResponse<GTVPostUsageEventsResponseDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gtv/processusageevents/${params.clientId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GTVPostUsageEventsResponseDTO>;
      })
    );
  }
  /**
   * @param params The `GTVService.ProcessUsageEventsParams` containing the following parameters:
   *
   * - `clientId`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  ProcessUsageEvents(params: GTVService.ProcessUsageEventsParams): __Observable<GTVPostUsageEventsResponseDTO> {
    return this.ProcessUsageEventsResponse(params).pipe(
      __map(_r => _r.body as GTVPostUsageEventsResponseDTO)
    );
  }

  /**
   * @param params The `GTVService.ProcessInvoiceReadyNotificationParams` containing the following parameters:
   *
   * - `gtvInvoicesReadyDTO`:
   *
   * - `Authorization`: Bearer token
   */
  ProcessInvoiceReadyNotificationResponse(params: GTVService.ProcessInvoiceReadyNotificationParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.gtvInvoicesReadyDTO;
    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gtv/processinvoicereadynotification`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `GTVService.ProcessInvoiceReadyNotificationParams` containing the following parameters:
   *
   * - `gtvInvoicesReadyDTO`:
   *
   * - `Authorization`: Bearer token
   */
  ProcessInvoiceReadyNotification(params: GTVService.ProcessInvoiceReadyNotificationParams): __Observable<null> {
    return this.ProcessInvoiceReadyNotificationResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param Authorization Bearer token
   * @return Success
   */
  GetBillCyclesNotInSimulateStatusResponse(Authorization?: string): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Authorization != null) __headers = __headers.set('Authorization', Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/gtv/billcyclesnotinsimulatestatus`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      })
    );
  }
  /**
   * @param Authorization Bearer token
   * @return Success
   */
  GetBillCyclesNotInSimulateStatus(Authorization?: string): __Observable<Array<string>> {
    return this.GetBillCyclesNotInSimulateStatusResponse(Authorization).pipe(
      __map(_r => _r.body as Array<string>)
    );
  }

  /**
   * @param params The `GTVService.GetChargeCategoryByNameParams` containing the following parameters:
   *
   * - `name`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  GetChargeCategoryByNameResponse(params: GTVService.GetChargeCategoryByNameParams): __Observable<__StrictHttpResponse<Array<GTVChargeCategoryDTO>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/gtv/chargecategorylookup/${params.name}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GTVChargeCategoryDTO>>;
      })
    );
  }
  /**
   * @param params The `GTVService.GetChargeCategoryByNameParams` containing the following parameters:
   *
   * - `name`:
   *
   * - `Authorization`: Bearer token
   *
   * @return Success
   */
  GetChargeCategoryByName(params: GTVService.GetChargeCategoryByNameParams): __Observable<Array<GTVChargeCategoryDTO>> {
    return this.GetChargeCategoryByNameResponse(params).pipe(
      __map(_r => _r.body as Array<GTVChargeCategoryDTO>)
    );
  }

  /**
   * @param params The `GTVService.SyncClientToGtvParams` containing the following parameters:
   *
   * - `clientId`:
   *
   * - `Authorization`: Bearer token
   */
  SyncClientToGtvResponse(params: GTVService.SyncClientToGtvParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gtv/syncClientToGtv/${params.clientId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `GTVService.SyncClientToGtvParams` containing the following parameters:
   *
   * - `clientId`:
   *
   * - `Authorization`: Bearer token
   */
  SyncClientToGtv(params: GTVService.SyncClientToGtvParams): __Observable<null> {
    return this.SyncClientToGtvResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `GTVService.ClearBillingMinimumParams` containing the following parameters:
   *
   * - `clientId`:
   *
   * - `Authorization`: Bearer token
   */
  ClearBillingMinimumResponse(params: GTVService.ClearBillingMinimumParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
  
    if (params.Authorization != null) {
      __headers = __headers.set('Authorization', params.Authorization.toString());
    }
  
    const req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/gtv/cleargtvminimums/${params.clientId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      }
    );
  
    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * @param params The `GTVService.ClearBillingMinimum` containing the following parameters:
   *
   * - `clientId`:
   *
   * - `Authorization`: Bearer token
   */
    
  ClearBillingMinimum(params: GTVService.ClearBillingMinimumParams): __Observable<null> {
    return this.ClearBillingMinimumResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }
  
}

module GTVService {

  /**
   * Parameters for ProcessUsageEvents
   */
  export interface ProcessUsageEventsParams {
    clientId: string;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for ProcessInvoiceReadyNotification
   */
  export interface ProcessInvoiceReadyNotificationParams {
    gtvInvoicesReadyDTO?: GTVInvoicesReadyDTO;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for GetChargeCategoryByName
   */
  export interface GetChargeCategoryByNameParams {
    name: string;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for SyncClientToGtv
   */
  export interface SyncClientToGtvParams {
    clientId: string;

    /**
     * Bearer token
     */
    Authorization?: string;
  }

  /**
   * Parameters for ClearBillingMinimum
   */
  export interface ClearBillingMinimumParams {
    clientId: string;

     /**
     * Bearer token
     */
    Authorization?: string; 
  }
}

export { GTVService }
